import React, { useContext, useEffect, useState } from 'react';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
	Stack,
	Typography,
} from '@mui/material';

import config from '../../hoa-config';
import datastore from '../../store/hoa-datastore';
import { GlobalContext } from '../../context/hoa-global-context';
import ConfiguratorModuleSelector from './module-selection/hoa-configurator-module-selector';

export default function DataFieldConfigurator() {
	const [view, setView] = useState('org');
	const [orgId, setOrgId] = useState('');
	const [orgName, setOrgName] = useState('');
	const [error, setError] = useState<any>({});
	const { updateDataFieldConfigurator, view: views, updateView, changeActiveMenu } = useContext<any>(GlobalContext);

	const resetDefaultValue = () => {
		updateDataFieldConfigurator({
			data: [],
			count: null,
			pageNumber: 1,
			isLastPage: false,
			fetchingFilteredData: false,
			options: {},
		});
	};

	useEffect(() => {
		resetDefaultValue();
	}, []);

	useEffect(() => {
		if (views === 'back-to-org') {
			setView('org');
			updateView('back-to-list');
			resetDefaultValue();
			changeActiveMenu('datafieldconfigurator');
		}
	}, [views]);

	const handleProceed = () => {
		if (checkError()) {
			return;
		}
		setView('module');
	};

	const checkError = () => {
		const error: any = {};
		let isEmpty = false;

		if (!orgId) {
			error['orgId'] = true;
			isEmpty = true;
		}

		setError(error);
		return isEmpty;
	};

	const handleOrganizationSelection = (event: SelectChangeEvent) => {
		const selectedData = event.target.value as any;
		setOrgId(selectedData);
		const orgName = config.hoaOrganizations.find((org: any) => org.id === selectedData)?.name;
		setOrgName(orgName);
	};

	return (
		<>
			{view === 'org' ? (
				<>
					<Card
						style={{
							width: 608,
							margin: '168px auto',
						}}
					>
						<CardContent
							style={{
								display: 'flex',
								margin: '10px',
								gap: '32px',
								flexDirection: 'column',
							}}
						>
							<Stack flexDirection={'column'} gap={'16px'}>
								<Typography fontSize={'24px'} fontWeight={700} color={'#3E3E3E'}>
									Data Field Configurator
								</Typography>
								<Typography fontSize={'18px'} fontWeight={400} color={'#787878'}>
									Choose the organization you wish to configure the data field for.
								</Typography>
							</Stack>
							<FormControl
								sx={{
									width: 300,
								}}
							>
								<InputLabel id='organization-select-label'>Organization</InputLabel>
								<Select
									labelId='organization-select-label'
									id='organization-select'
									label='Organization'
									value={orgId || ''}
									onChange={handleOrganizationSelection}
									error={error['orgId'] || false}
									variant='standard'
								>
									{config.hoaOrganizations.map((org: any) => {
										return (
											<MenuItem key={org.id} value={org.id}>
												{org.name}
											</MenuItem>
										);
									})}
								</Select>
								<FormHelperText error={error['orgId'] || false}>
									{error['orgId'] ? 'Please select an organization' : ''}
								</FormHelperText>
							</FormControl>
						</CardContent>
						<CardActions
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'flex-end',
								marginRight: '16px',
								marginBottom: '16px',
							}}
						>
							<Button
								onClick={handleProceed}
								size='small'
								style={{
									backgroundColor: '#3576E5',
									color: '#FFF',
									width: 'auto',
									padding: '6px 14px',
								}}
							>
								Proceed
							</Button>
						</CardActions>
					</Card>
				</>
			) : (
				<div
					style={{
						height: window.innerHeight - datastore.responsiveHeightWithtab + 100,
						overflowY: 'auto',
					}}
				>
					<ConfiguratorModuleSelector orgId={orgId} orgName={orgName} />
				</div>
			)}
		</>
	);
}
